import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static FOCUS_STATE_KEY = "inloop-search-focus-state"

  connect() {
    this.timeout = null
    this.restoreFocusState()
  }

  search() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value.trim()
      const url = new URL(window.location.href)
      url.searchParams.delete("page")
      url.searchParams.delete("shared_page")
      this.persistFocusState(query)

      if (query) {
        url.searchParams.set("q", query)
      } else {
        url.searchParams.delete("q")
      }

      // Use Turbo to navigate without full page reload
      Turbo.visit(url.toString(), { action: "replace" })
    }, 300) // Debounce for 300ms
  }

  clear() {
    this.inputTarget.value = ""
    const url = new URL(window.location.href)
    url.searchParams.delete("page")
    url.searchParams.delete("shared_page")
    url.searchParams.delete("q")
    this.persistFocusState("")
    Turbo.visit(url.toString(), { action: "replace" })
  }

  filterByTeam(event) {
    const selectedTeam = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.delete("page")
    url.searchParams.delete("shared_page")

    if (!selectedTeam || selectedTeam === "all") {
      url.searchParams.delete("team_id")
    } else {
      url.searchParams.set("team_id", selectedTeam)
    }

    Turbo.visit(url.toString(), { action: "replace" })
  }

  persistFocusState(query) {
    try {
      const state = {
        path: window.location.pathname,
        query,
        start: this.inputTarget.selectionStart,
        end: this.inputTarget.selectionEnd
      }
      sessionStorage.setItem(this.constructor.FOCUS_STATE_KEY, JSON.stringify(state))
    } catch (_error) {
      // Ignore storage errors and continue with navigation.
    }
  }

  restoreFocusState() {
    try {
      const raw = sessionStorage.getItem(this.constructor.FOCUS_STATE_KEY)
      if (!raw) return

      const state = JSON.parse(raw)
      sessionStorage.removeItem(this.constructor.FOCUS_STATE_KEY)

      if (!state || state.path !== window.location.pathname) return
      if ((state.query || "") !== this.inputTarget.value.trim()) return

      this.inputTarget.focus({ preventScroll: true })

      if (typeof state.start === "number" && typeof state.end === "number") {
        this.inputTarget.setSelectionRange(state.start, state.end)
      }
    } catch (_error) {
      // Ignore malformed state and continue without focus restoration.
    }
  }
}
